import classNames from "classnames";
import StatusBadge from "./StatusBadge";
import { formatNumber, formatRatio, ratioTone, STATUS_META, formatEventDateTime } from "../utils";

// Small inline sparkline, no chart library needed for this scale.
const Sparkline = ({ points = [] }) => {
  let values = points;
  if (typeof values === "string") {
    try {
      values = JSON.parse(values);
    } catch {
      values = [];
    }
  }
  if (!Array.isArray(values) || values.length === 0) return null;

  const w = 64;
  const h = 24;
  const max = Math.max(...values, 1);
  const step = w / Math.max(values.length - 1, 1);
  const path = values
    .map((v, i) => `${i === 0 ? "M" : "L"}${(i * step).toFixed(1)},${(h - (v / max) * h).toFixed(1)}`)
    .join(" ");

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="ea-sparkline" aria-hidden="true">
      <path d={path} fill="none" stroke="#535862" strokeWidth="1.5" />
    </svg>
  );
};

const EventTableRow = ({ event, isSelected, onSelect }) => {
  const statusMeta = STATUS_META[event.status] || STATUS_META.ended;

  return (
    <tr
      className={classNames("ea-table__row", { "ea-table__row--selected": isSelected })}
      onClick={() => onSelect(isSelected ? null : event.event_uuid)}
      tabIndex={0}
      role="button"
      aria-pressed={isSelected}
    >
      <td className="ea-table__cell ea-table__cell--name" title={event.name}>{event.name}</td>
      <td className="ea-table__cell ea-table__cell--date">{formatEventDateTime(event.start_date)}</td>
      <td className="ea-table__cell ea-table__cell--date">{formatEventDateTime(event.end_date)}</td>
      <td className="ea-table__cell ea-table__cell--num">{formatNumber(event.impressions)}</td>
      <td className="ea-table__cell ea-table__cell--num">{formatNumber(event.views)}</td>
      <td className="ea-table__cell ea-table__cell--num">
        <span className={`ea-ratio ea-ratio--${ratioTone(event.ratio)}`}>{formatRatio(event.ratio)}</span>
      </td>
      <td className="ea-table__cell">
        <StatusBadge label={statusMeta.label} color={statusMeta.color} />
      </td>
      <td className="ea-table__cell">
        <Sparkline points={event.sparkline} />
      </td>
    </tr>
  );
};

export default EventTableRow;
